export default class Uv_virtualKeyboard {
  constructor(Vue) {
    if (Vue) {
      this.vue = Vue;
    }
  }

  elements = {
    main: null,
    keysContainer: null,
    keys: [],
  };

  mainListener = () => {};

  eventHandlers = {
    oninput: null,
    onclose: null,
  };

  properties = {
    value: "",
    capsLock: false,
  };

  init(callback) {
    // Create main elements
    this.elements.main = document.createElement("div");
    this.elements.keysContainer = document.createElement("div");

    // Setup main elements
    this.elements.main.classList.add("keyboard", "keyboard--hidden");
    this.elements.keysContainer.classList.add("keyboard__keys");
    this.elements.keysContainer.appendChild(this._createKeys());

    this.elements.keys =
      this.elements.keysContainer.querySelectorAll(".keyboard__key");

    // Add to DOM
    this.elements.main.appendChild(this.elements.keysContainer);
    document.body.appendChild(this.elements.main);
    let $this = this;
    const delegate = (selector) => (cb) => (e) =>
      e.target.matches(selector) && cb(e);
    const inputDelegate = delegate("input");
    $this.mainListener = (el) => {
      if (el.target.nodeName == "INPUT") {
        $this.open(el.target.value, (currentValue) => {
          el.target.value = currentValue;
          el.target.dispatchEvent(new Event("input"));
          callback();
        });
      }
    };
    document.addEventListener("click", $this.mainListener);
    // Automatically use keyboard for elements with .use-keyboard-input
    /*document.querySelectorAll("input").forEach(element => {
            
            $this.mainListener = () => {
                $this.open(element.value, currentValue => {
                    element.value = currentValue;
                    element.dispatchEvent(new Event('input'))
                    callback();
                });
            }
            element.addEventListener("focus", $this.mainListener);
           
        });*/
    // se agrega codigo para cerrar el teclado al hacer click fuera del area destinada para teclado
    document.addEventListener("click", (evt) => {
      var KeyElement = document.getElementsByClassName("keyboard__keys"),
        targetElement = evt.target; // clicked element

      /* if(targetElement.className == KeyElement[0].className || targetElement.nodeName == "INPUT" )  {
                return;
            }else{
                this.close();
            }*/

      do {
        //if (targetElement.className == KeyElement[0].className || targetElement.className == 'use-keyboard-input' ) {
        // This is a click inside. Do nothing, just return.

        if (
          targetElement.className == KeyElement[0].className ||
          targetElement.nodeName == "INPUT"
        ) {
          return;
        }
        // Go up the DOM
        targetElement = targetElement.parentNode;
      } while (targetElement);

      // This is a click outside.
      this.close();
    });
  }

  _createKeys() {
    const fragment = document.createDocumentFragment();
    const keyLayout = [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "0",
      "backspace",
      "q",
      "w",
      "e",
      "r",
      "t",
      "y",
      "u",
      "i",
      "o",
      "p",
      "caps",
      "a",
      "s",
      "d",
      "f",
      "g",
      "h",
      "j",
      "k",
      "l",
      "enter",
      "done",
      "z",
      "x",
      "c",
      "v",
      "b",
      "n",
      "m",
      ",",
      ".",
      "?",
      "ñ",
      "space",
      "@",
    ];

    // Creates HTML for an icon
    const createIconHTML = (icon_name) => {
      return `<i class="lni ${icon_name}"></i>`;
    };

    keyLayout.forEach((key) => {
      const keyElement = document.createElement("button");
      const insertLineBreak =
        ["backspace", "p", "enter", "?"].indexOf(key) !== -1;

      // Add attributes/classes
      keyElement.setAttribute("type", "button");
      keyElement.classList.add("keyboard__key");

      switch (key) {
        case "backspace":
          keyElement.classList.add("keyboard__key--wide");
          keyElement.innerHTML = createIconHTML("lni-arrow-left-circle");

          keyElement.addEventListener("click", () => {
            this.properties.value = this.properties.value.substring(
              0,
              this.properties.value.length - 1
            );
            this._triggerEvent("oninput");
          });

          break;

        case "caps":
          keyElement.classList.add(
            "keyboard__key--wide",
            "keyboard__key--activatable"
          );
          keyElement.innerHTML = createIconHTML("lni-chevron-up-circle");

          keyElement.addEventListener("click", () => {
            this._toggleCapsLock();
            keyElement.classList.toggle(
              "keyboard__key--active",
              this.properties.capsLock
            );
          });

          break;

        case "enter":
          keyElement.classList.add("keyboard__key--wide");
          keyElement.innerHTML = createIconHTML("lni-enter");

          keyElement.addEventListener("click", () => {
            this.properties.value += "\n";
            this._triggerEvent("oninput");
          });

          break;

        case "space":
          keyElement.classList.add("keyboard__key--extra-wide");
          keyElement.innerHTML = createIconHTML("lni-minus");

          keyElement.addEventListener("click", () => {
            this.properties.value += " ";
            this._triggerEvent("oninput");
          });

          break;

        case "done":
          keyElement.classList.add(
            "keyboard__key--wide",
            "keyboard__key--dark"
          );
          keyElement.innerHTML = createIconHTML("lni-checkmark-circle");

          keyElement.addEventListener("click", () => {
            this.close();
            this._triggerEvent("onclose");
          });

          break;

        default:
          keyElement.textContent = key.toLowerCase();

          keyElement.addEventListener("click", () => {
            this.properties.value += this.properties.capsLock
              ? key.toUpperCase()
              : key.toLowerCase();
            this._triggerEvent("oninput");
          });

          break;
      }

      fragment.appendChild(keyElement);

      if (insertLineBreak) {
        fragment.appendChild(document.createElement("br"));
      }
    });

    return fragment;
  }

  _triggerEvent(handlerName) {
    if (typeof this.eventHandlers[handlerName] == "function") {
      this.eventHandlers[handlerName](this.properties.value);
    }
  }

  _toggleCapsLock() {
    this.properties.capsLock = !this.properties.capsLock;

    for (const key of this.elements.keys) {
      if (key.childElementCount === 0) {
        key.textContent = this.properties.capsLock
          ? key.textContent.toUpperCase()
          : key.textContent.toLowerCase();
      }
    }
  }

  open(initialValue, oninput, onclose) {
    this.properties.value = initialValue || "";
    this.eventHandlers.oninput = oninput;
    this.eventHandlers.onclose = onclose;
    this.elements.main.classList.remove("keyboard--hidden");
    // codigo para ampliar el scroll segun la altura del teclado virtual
    let keyboarHeight = this.elements.main.clientHeight;

    document.getElementById("app").style.marginBottom = keyboarHeight + "px";
  }

  close() {
    this.properties.value = "";
    this.eventHandlers.oninput = oninput;
    this.eventHandlers.onclose = onclose;
    this.elements.main.classList.add("keyboard--hidden");
    // codigo para limpiar el scroll
    document.getElementById("app").style.marginBottom = "0px";
  }

  destroyListener() {
    document.removeEventListener("click", this.mainListener);
  }
}
